import {useEffect} from 'react';

function useReload(reload, delay) {
  useEffect(() => {
    if (delay !== null) {
      const intervalId = setInterval(reload, delay);

      return () => clearInterval(intervalId);
    }
  }, [delay]);
}

export default useReload;
